import { render, staticRenderFns } from "./ProductChannelCardListCmp.vue?vue&type=template&id=fc3e977e&scoped=true&"
import script from "./ProductChannelCardListCmp.vue?vue&type=script&lang=js&"
export * from "./ProductChannelCardListCmp.vue?vue&type=script&lang=js&"
import style0 from "./ProductChannelCardListCmp.vue?vue&type=style&index=0&id=fc3e977e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3e977e",
  null
  
)

export default component.exports